/**
 * Readable two-word slugs (`brave-otter`) for auto-generated names people
 * need to tell apart at a glance — provisioned email users in the web app,
 * workflow forks in the API.
 *
 * @module ReadableSlug
 */

const ADJECTIVES = [
  'brave', 'calm', 'clever', 'cool', 'eager', 'fair', 'fast', 'fierce',
  'gentle', 'glad', 'golden', 'grand', 'happy', 'keen', 'kind', 'lively',
  'lucky', 'merry', 'mighty', 'noble', 'polite', 'proud', 'quick', 'quiet',
  'rapid', 'sharp', 'shiny', 'smart', 'smooth', 'solid', 'steady', 'stout',
  'strong', 'sunny', 'super', 'sweet', 'swift', 'tall', 'tidy', 'tough',
  'vivid', 'warm', 'wild', 'wise', 'witty', 'young', 'zany', 'zippy',
  'bold', 'crisp',
];

const ANIMALS = [
  'ant', 'bear', 'cat', 'crow', 'deer', 'dove', 'duck', 'eagle',
  'elk', 'fawn', 'fish', 'fox', 'frog', 'goat', 'gull', 'hare',
  'hawk', 'ibis', 'jay', 'kiwi', 'lark', 'lion', 'lynx', 'mole',
  'moth', 'newt', 'okapi', 'otter', 'owl', 'panda', 'pike', 'puma',
  'quail', 'robin', 'seal', 'shrew', 'sloth', 'snake', 'stork', 'swan',
  'tiger', 'toad', 'viper', 'whale', 'wolf', 'wren', 'yak', 'zebra',
  'crane', 'finch',
];

const pick = (words: readonly string[]): string =>
  words[Math.floor(Math.random() * words.length)]!;

/** A random `{adjective}-{animal}` slug, e.g. `brave-otter`. */
export const readableSlug = (): string => `${pick(ADJECTIVES)}-${pick(ANIMALS)}`;
